import { IconTable, IconDots } from '@tabler/icons-react'; // Assuming you are using Tabler icons, adjust imports as needed
import { useState, useRef, useEffect } from 'react';
import PopupArrow from '../ui/poparrow';


interface InfoCardProps {
    title: string;
    number_document: number;
    id: string; // Add this line
    onDotsClick?: () => void; // Optional event handler for dots icon click
}

const KnowLedgeCard: React.FC<InfoCardProps> = ({ title, id, number_document, onDotsClick }) => {

    const [openDropdownId, setOpenDropdownId] = useState<string | null>(null);
    const dropdownRef = useRef<HTMLDivElement>(null);

    const handleToggle = (id: string) => {
        setOpenDropdownId((prevId) => (prevId === id ? null : id));
        // setOpenDropdownId(id)
    };


    const handleClickOutside = (event: MouseEvent) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
            setOpenDropdownId(null);
        }
    };

    useEffect(() => {
        if (openDropdownId !== null) {
            document.addEventListener('mousedown', handleClickOutside);
        } else {
            document.removeEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [openDropdownId]);
    

    return (
        <div className='border-b hover:bg-gray-200 p-2' onClick={onDotsClick}>
            <div className='flex items-center justify-between'>
                <div className='flex flex-col'>
                    <div className='flex items-center space-x-2'>
                        {<IconTable size={16} stroke={1} />}
                        <span className='flex-grow overflow-hidden text-ellipsis whitespace-nowrap'>{title}</span>
                    </div>
                    <span className='text-sm ml-2 text-slate-500'>{number_document} document</span>
                </div>
                
                <span className='flex items-center justify-center mr-4  hover:bg-white rounded-md py-1 px-2'>
                    <IconDots size={16} className='cursor-pointer  text-slate-500' onClick={()=> handleToggle(id)} />
                     {openDropdownId === id && (
                     <div className="card border rounded-lg shadow-lg p-2 z-50 flex flex-col absolute bg-white mt-16 mr-2 "  ref={dropdownRef}>
                        <button
                            className=""
                            onClick={(e) => {
                                e.stopPropagation();
                                // Handle Delete action
                                // deleteAgents(data?.id)
                            }}
                        >
                            Delete
                        </button>
                    </div>
                     )}
                </span>
             </div>
        </div>
    );
};

export default KnowLedgeCard;
